import { Entity } from "../helpers/Entity"


export type ReminderAttributesDto = {
    accountId: string
    reminderId: string
    numberOfDays: number
    period: string
    subject: string
    fromName: string
    fromEmail: string
    content: string
    buttonLabel: string
    includeAttachment: boolean
}

export type ReminderDto = {
    id: string
    type: string
    attributes: ReminderAttributesDto
}

export default class Reminder implements Entity {
    private dto: ReminderDto
    constructor(dto: ReminderDto) {
        this.dto = dto
    }
    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "reminders"
    }

    getId(): string {
        return this.dto.id
    }

    getAccountId(): string {
        return this.dto.attributes.accountId
    }

    getReminderId(): string {
        return this.dto.attributes.reminderId
    }

    getNumberOfDays(): number {
        return this.dto.attributes.numberOfDays
    }

    getPeriod(): string {
        return this.dto.attributes.period
    }

    getSubject(): string {
        return this.dto.attributes.subject
    }

    getFromName(): string {
        return this.dto.attributes.fromName
    }

    getFromEmail(): string {
        return this.dto.attributes.fromEmail
    }

    getContent(): string {
        return this.dto.attributes.content
    }

    getButtonLabel(): string {
        return this.dto.attributes.buttonLabel
    }

    getIncludeAttatchment(): boolean {
        return this.dto.attributes.includeAttachment
    }
}


// WEBPACK FOOTER //
// ./src/state/reminder/Reminder.ts